module.exports = __webpack_public_path__ + "static/media/tapete01.61ac5478.svg";